// Hanging indent for wrapped editor lines (the CodeMirror styling
// recipe): a wrapped continuation aligns under its line's own leading
// whitespace instead of falling back to column 0 — without this, a
// deeply indented long line (a UDF service's inline script content in
// the Raw configuration JSON) wraps "skewed" against the left edge.

/** How many characters of hanging indent a line's continuations get —
 *  its leading whitespace, tabs at their tab-size, capped so extreme
 *  indents keep a readable wrap width. */
export function wrapIndentCh(text: string, tabSize = 4): number {
  let width = 0;
  for (const ch of text) {
    if (ch === " ") width += 1;
    else if (ch === "\t") width += tabSize;
    else break;
  }
  return Math.min(width, 48);
}
